import { render, staticRenderFns } from "./ReportSuspectStats.vue?vue&type=template&id=7bd00db6&scoped=true"
import script from "./ReportSuspectStats.vue?vue&type=script&lang=js"
export * from "./ReportSuspectStats.vue?vue&type=script&lang=js"
import style0 from "./ReportSuspectStats.vue?vue&type=style&index=0&id=7bd00db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd00db6",
  null
  
)

export default component.exports